import React from 'react';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { useSuperDuper } from '../context/SuperDuperContext';
import MagazineLevelSection from './magazines/MagazineLevelSection';
import { MAGAZINE_LEVELS } from './magazines/levelConfig';

const MagazinesTab = () => {
  const { magazines, magazinesLoading, magazinesError } = useSuperDuper();

  return (
    <Box sx={{ mt: { xs: 1, sm: 2, md: 4 } }}>
      <Typography
        variant="h5"
        sx={{ color: '#c64110', fontWeight: 700, mb: 3, fontSize: { xs: '1.25rem', sm: '1.5rem' } }}
      >
        Magazine Manager
      </Typography>

      {magazinesLoading && !magazines && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
          <CircularProgress />
        </Box>
      )}

      {magazinesError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {magazinesError}
        </Alert>
      )}

      {magazines && MAGAZINE_LEVELS.map((config) => (
        <MagazineLevelSection key={config.level} config={config} />
      ))}
    </Box>
  );
};

export default MagazinesTab;
